import { useSyncExternalStore } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/** Undefined where `matchMedia` is not implemented — jsdom, and older browsers. */
const mediaQuery = (): MediaQueryList | undefined =>
  typeof matchMedia === 'function' ? matchMedia(REDUCED_MOTION_QUERY) : undefined;

const subscribe = (onStoreChange: () => void): (() => void) => {
  const media = mediaQuery();
  media?.addEventListener('change', onStoreChange);

  return (): void => {
    media?.removeEventListener('change', onStoreChange);
  };
};

const isReduced = (): boolean => mediaQuery()?.matches ?? false;

const isReducedOnServer = (): boolean => false;

/**
 * Whether this viewer has asked for less movement. Read as an external store
 * rather than into state, for the same reason `useNow` is: the alternative is a
 * `setState` in an effect and a cascading render on mount.
 */
export const useIsMotionReduced = (): boolean =>
  useSyncExternalStore(subscribe, isReduced, isReducedOnServer);
